import ReactQuill from "react-quill"
import "quill/dist/quill.snow.css"

const Clipboard = ReactQuill.Quill.import("modules/clipboard") as any
const convertOriginal = Clipboard.prototype.convert

Clipboard.prototype.convert = function (arg: any, formats: any) {
    return convertOriginal.call(this, typeof arg === "string" ? { html: arg } : arg, formats)
}

export default ReactQuill.Quill
